export default "__VITE_ASSET__2hezTgHP__"